module.exports = __webpack_public_path__ + "static/domobile-50b206a03c4da9d0950cf4cd3414567b.jpeg";